import { Box } from '@mui/material';
import { MprcChipChoice, MprcSpinnerIndicator } from 'components';
import { IconFilter } from 'components/icons';
import { MprcRibbonScroll } from 'components/MprcRibbonScroll';
import { FeedType, QuickFilterDto, UserSelectionEntityType, UserSelectionEntry } from 'generated/CoreApi_v1';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useSession } from 'providers/SessionProvider';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IAdvFilterResult } from 'views/general/AdvancedFilter/interfaces';
////////////////////////////////////////////////////////////////////////////

export interface QuickFilterFeedOptions {
    key: string;
    label: string;
    filter?: QuickFilterDto;
}

////////////////////////////////////////////////////////////////////////////

interface IProps {
    expandedAdvFilter?: boolean;
    selectedCommands: IAdvFilterResult[];
    feedType: FeedType;
    reload?: boolean;
    onSelectedExpandedAdvFilter?: (selected: boolean) => void;
    onChange: (selected: boolean, quickFilter: QuickFilterDto) => void;
    onGetOptions: () => Promise<QuickFilterDto[]>;
    onError: (error: any) => void;
}

/**
 * Filtro Rápidos dos feeds
 * @param props
 */
export const QuickFilter: React.FC<IProps> = (props) => {

    const { feedType, expandedAdvFilter, selectedCommands, onChange, onSelectedExpandedAdvFilter, onGetOptions, onError, reload } = props;

    const api = useCoreApi();
    const session = useSession();

    const { t } = useTranslation("knowledge");
    const [loading, setLoading] = useState<boolean>(true);
    const [saveClick, setSaveClick] = useState<string | undefined>(undefined);

    const filterOptions = useRef<QuickFilterDto[]>([]);
    const selectedRef = useRef<HTMLElement | undefined>(undefined);

    ////////////////////////////////////////////////////////////////////////////

    const handleSelectOption = (quickFilter: QuickFilterDto) => {
        const selected = !selectedCommands.some(x => x.quickFilter == quickFilter);

        onChange(selected, quickFilter);

        if (selected) setSaveClick(quickFilter.quickFilterId);
    };

    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT
    ////////////////////////////////////////////////////////////////////////////

    // Ao carregar os dados
    useEffect(() => {
        async function getData() {
            try {
                filterOptions.current = await onGetOptions();
            }
            catch (e) {
                onError(e);
            }
            finally {
                setLoading(false);
            }
        }

        if (loading) getData();

    }, [loading]);

    // Ao carregar os dados
    useEffect(() => {
        setLoading(true);
    }, [reload]);

    /// Conta click dos filtros rápidos
    useEffect(() => {
        if (saveClick != undefined) {
            var payload = {
                userId: session.user.userId,
                entries: [{
                    entityType: UserSelectionEntityType.QuickFilter,
                    entityId: saveClick,
                    otherInfo: feedType.toString(),
                } as UserSelectionEntry]
            };

            api.v1.user.saveSelectionHistoryClick(payload)
                .then(() => { })
                .catch((e) => {
                    onError(e);
                })
                .finally(() => setSaveClick(undefined));
        }
    }, [saveClick]);

    /// Reposiciona o Ribbon.
    useEffect(() => {
        var selectedFilter = filterOptions.current.filter(p => selectedCommands.some(x => x.quickFilter?.quickFilterId == p.quickFilterId));
        if (selectedFilter != null && selectedFilter.length > 0) {
            var el = document.getElementById(selectedFilter[0].quickFilterId);
            if (el != null) selectedRef.current = el;
        }
    }, [filterOptions.current]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcRibbonScroll selectedRef={selectedRef.current}>
            {
                expandedAdvFilter != undefined &&
                <MprcChipChoice
                    label={t("Feed.QuickFilter.AdvancedFilterText")}
                    icon={<Box paddingLeft="8px"><IconFilter color="inherit" size='sm' /></Box>}
                    selected={expandedAdvFilter}
                    onClick={() => onSelectedExpandedAdvFilter && onSelectedExpandedAdvFilter(!expandedAdvFilter)}
                />
            }

            {
                loading
                    ?
                    <Box sx={{ mt: 0.5, width: 100 }}>
                        <MprcSpinnerIndicator />
                    </Box>
                    :
                    filterOptions.current.map(item =>
                        <MprcChipChoice
                            key={item.quickFilterId}
                            id={item.quickFilterId}
                            label={item.name}
                            selectedBgColor="warning"
                            selected={selectedCommands.some(x => x.quickFilter?.quickFilterId == item.quickFilterId)}
                            onClick={() => handleSelectOption(item)}
                        />
                    )
            }

        </MprcRibbonScroll>
    );
};
